module.exports = __webpack_public_path__ + "img/header-weddingRingsSoleil@2x.3c99097.jpg";